if (!customElements.get('complement-product')) {
  customElements.define(
    'complement-product',
    class ComplementProduct extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variant_id = this.form.querySelector('[name=id]').value;
        this.product_title = this.form.querySelector('[name=title]').value;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        // this.added = this.submitButton.classList.contains("added");
        this.addons_container = this.closest('.product-addons-container');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if(this.addons_container.hasAttribute('selected-addons')){
            let addon_ids_string = this.addons_container.getAttribute('selected-addons');
            if( addon_ids_string.includes(this.variant_id)){
              // this.addons_container.removeAttribute('selected-addons');
              addon_ids_string = addon_ids_string.split(',').filter(id => id.trim() !== this.variant_id ).join(',');
              this.addons_container.setAttribute('selected-addons',addon_ids_string);
              this.submitButton.classList.remove("added");
            }
            else{
              addon_ids_string = addon_ids_string + `,${this.variant_id}`;
              this.addons_container.setAttribute('selected-addons',addon_ids_string);
              this.submitButton.classList.add("added");
            }
          }
        else{
              this.addons_container.setAttribute('selected-addons',this.variant_id);
              this.submitButton.classList.add("added");
        }
      }
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}